import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { leadEndpoints } from '@/lib/api/endpoints';
import { leadKeys } from '@/lib/queryKeys';
import type { AssignableUsersResponse } from '@/types/settings';

/**
 * All lead-owning users (company-wide `leads:edit` holders), served under
 * `leads:view` and NOT scoped to the actor's manual assignment authority.
 * Backs the CONFIGURATION pickers — the fallback user and routing "direct
 * user" destination — which must offer any valid owner, unlike
 * `useAssignableUsers` (scope-filtered, for the per-lead assignee picker).
 */
export function useLeadOwners(options?: { enabled?: boolean }) {
  return useApiQuery<AssignableUsersResponse>({
    queryKey: leadKeys.assignableOwners(),
    queryFn: () =>
      apiGet<AssignableUsersResponse>(operationsClient, leadEndpoints.assignableOwners()),
    enabled: options?.enabled,
    showErrorToast: false,
  });
}
